import { ReactComponent as Trash } from '../../components/icons/trash.svg';
import { ReactComponent as SearchIcon } from '../../components/icons/search.svg';
import { ReactComponent as AddIcon } from '../../components/icons/add-icon.svg';
import SortArrows from '../../components/icons/sort-arrows.jsx';
import CustomButton from '../../components/components/custom_button/customButton';
import CustomInput from '../../components/components/custom_input/customInput';
import {
  setSearchQuery,
  setSearchValue,
  setTitle,
  setDateFrom,
  setDateTo,
  setAddress,
  setAuthorName,
  setStatus,
  setSorting,
  setCheckedItems,
} from '../../store/encyclopediaTabSlice';

// Actions for encyclopedia table
export const encyclopediaActions = {
  deleteSelected: async (selectedIds, dispatch, fetchArticles, ...fetchParams) => {
    if (selectedIds.length === 0) {
      alert('Nie zaznaczono żadnych artykułów.');
      return;
    }

    if (!window.confirm(`Czy na pewno chcesz usunąć ${selectedIds.length} artykuł(ów)?`)) {
      return;
    }

    try {
      const ApiService = (await import('../../components/api_services/apiService.jsx')).default;
      await ApiService.bulkDeleteArticles(selectedIds);
      dispatch(setCheckedItems([]));
      // Refresh the articles list
      fetchArticles(...fetchParams);
      alert('Artykuły zostały usunięte.');
    } catch (error) {
      console.error('Błąd podczas usuwania artykułów:', error);
      alert('Wystąpił błąd podczas usuwania artykułów.');
    }
  },
};

// Configuration for table headers
export const getHeaders = (
  sortBy,
  sortDirection,
  dispatch,
  setSorting,
  sortArrowColorActive,
  sortArrowColorInactive,
  rowsArticles,
  checkedItems,
  articlesData,
  setCheckedItems
) => [
  <input
    key="select-all"
    type="checkbox"
    checked={
      articlesData &&
      articlesData.length > 0 &&
      articlesData.every((id) => checkedItems.includes(id))
    }
    onChange={(e) => {
      if (e.target.checked && articlesData) {
        dispatch(setCheckedItems([...articlesData]));
      } else {
        dispatch(setCheckedItems([]));
      }
    }}
  />,
  <div key="id-header" className="table-columns-headers">
    <div>ID</div>
    <SortArrows
      upColor={sortBy === 'id' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'id' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'id') {
          dispatch(setSorting({ sortBy: 'id', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'id', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: 'createdAt', sortDirection: 'DESC' }));
          }
        }
      }}
    />
  </div>,
  <div key="title-header" className="table-columns-headers">
    <div>Nazwa miejsca</div>
    <SortArrows
      upColor={sortBy === 'title' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'title' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'title') {
          dispatch(setSorting({ sortBy: 'title', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'title', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: 'createdAt', sortDirection: 'DESC' }));
          }
        }
      }}
    />
  </div>,
  <div key="date-header" className="table-columns-headers">
    <div>Data dodania</div>
    <SortArrows
      upColor={sortBy === 'createdAt' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'createdAt' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'createdAt') {
          dispatch(setSorting({ sortBy: 'createdAt', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'createdAt', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: 'createdAt', sortDirection: 'DESC' }));
          }
        }
      }}
    />
  </div>,
  <div key="address-header" className="table-columns-headers">
    <div>Adres (ulica, kod, miasto)</div>
    <SortArrows
      upColor={sortBy === 'address' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'address' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'address') {
          dispatch(setSorting({ sortBy: 'address', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'address', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: 'createdAt', sortDirection: 'DESC' }));
          }
        }
      }}
    />
  </div>,
  <div key="author-header" className="table-columns-headers">
    <div>Autor</div>
    <SortArrows
      upColor={sortBy === 'authorName' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'authorName' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'authorName') {
          dispatch(setSorting({ sortBy: 'authorName', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'authorName', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: 'createdAt', sortDirection: 'DESC' }));
          }
        }
      }}
    />
  </div>,
  <div key="pin-header" className="table-columns-headers">
    <div>Pineska</div>
    <SortArrows
      upColor={sortBy === 'pinUrl' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'pinUrl' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'pinUrl') {
          dispatch(setSorting({ sortBy: 'pinUrl', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'pinUrl', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: 'createdAt', sortDirection: 'DESC' }));
          }
        }
      }}
    />
  </div>,
  <div key="status-header" className="table-columns-headers">
    <div>Status</div>
    <SortArrows
      upColor={sortBy === 'status' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'status' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'status') {
          dispatch(setSorting({ sortBy: 'status', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'status', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: 'createdAt', sortDirection: 'DESC' }));
          }
        }
      }}
    />
  </div>,
  <div key="actions-header">Akcje</div>,
];

// Column widths
export const headerWidths = [
  '42px', // checkbox
  '80px', // ID
  'minmax(200px, 3fr)', // Nazwa miejsca
  'minmax(140px, 2fr)', // Data dodania
  'minmax(200px, 3fr)', // Adres
  'minmax(150px, 2fr)', // Autor
  'minmax(100px, 1fr)', // Pineska
  'minmax(140px, 2fr)', // Status
  'minmax(120px, 1fr)', // Akcje
];

// Configuration for tabs
export const tabsConfig = (activeEncyclopediaTab, dispatch, setActiveEncyclopediaTab) => [
  {
    name: 'Encyklopedia',
    activeClass: activeEncyclopediaTab === 'Encyklopedia' ? 'is-active' : '',
    onClick: () => dispatch(setActiveEncyclopediaTab('Encyklopedia')),
    toggleActive: true,
  },
  {
    name: 'Podręczniki',
    activeClass: activeEncyclopediaTab === 'Podręczniki' ? 'is-active' : '',
    onClick: () => dispatch(setActiveEncyclopediaTab('Podręczniki')),
    toggleActive: true,
  },
];

// Configuration for buttons
export const buttonsConfig = (handleToggleAddModal) => [
  {
    icon: AddIcon,
    name: 'Dodaj nowy wpis',
    baseClass: 'custom-button-black',
    hoverClass: 'hover-effect',
    activeClass: '',
    onClick: () => {
      handleToggleAddModal();
    },
    toggleActive: false,
  },
];

// Configuration for left side (delete button)
export const leftSideConfig = (checkedItems, dispatch, fetchArticles, ...fetchParams) => [
  {
    component: CustomButton,
    props: {
      icon: Trash,
      name: 'Usuń zaznaczone',
      baseClass: 'custom-button-white',
      hoverClass: 'hover-effect',
      activeClass: '',
      borders: 'LRBT',
      onClick: () => encyclopediaActions.deleteSelected(checkedItems, dispatch, fetchArticles, ...fetchParams),
      toggleActive: false,
    },
  },
];

// Configuration for right side (search)
export const rightSideConfig = (searchValue, dispatch) => [
  {
    component: CustomInput,
    props: {
      icon: SearchIcon,
      placeholder: 'Szukaj',
      hoverClass: 'hover-effect',
      borders: 'LRBT',
      bordersClassPrefix: 'border-black-',
      baseClass: 'custom-input',
      activeClass: '',
      value: searchValue,
      onChange: (e) => {
        e.preventDefault();
        let value = e.target.value;
        dispatch(setSearchValue(value));
        if (value.length >= 3) {
          dispatch(setSearchQuery(value));
        } else {
          dispatch(setSearchQuery(null));
        }
      },
    },
  },
];

// Filter configuration for status dropdown
export const statusFilterOptions = [
  { value: null, label: 'wybierz' },
  { value: 'PENDING', label: 'do weryfikacji' },
  { value: 'APPROVED', label: 'aktywny' },
  { value: 'REJECTED', label: 'odrzucony' },
];

export const empty = [];




